// this is a js check to see if the screen is in our
// small media query size.  I'm using this as a value
// since changing it there would likely break other things
// anyway.  I'll add a note there to know to change this.
export const isSmallScreen = () =>
  window.document.documentElement.clientWidth <= 645;

// works on most browsers and works on IE10/11 and Surface
export const isNewTouchDevice = () =>
  "ontouchstart" in window ||
  (navigator.msMaxTouchPoints || navigator.maxTouchPoints) > 2;

// This just decides if touch events are enabled
// You should not assume a mouse will not be in use
export const isTouchDevice = () => "ontouchstart" in document.documentElement;

// As of iOS 13, Safari on iPad (in its default configuration) reports the same
// user-agent string as Safari on desktop MacOS. Currently there are no non-iOS/iPadOS
// Apple devices with multi-touch displays, so we can use that
// @see https://stackoverflow.com/questions/57765958/how-to-detect-ipad-and-ipad-os-version-in-ios-13-and-up
// @see https://forums.developer.apple.com/thread/119186
// @see https://github.com/GoogleWebComponents/model-viewer/issues/758
export const isiOS = () => {
  return (
    (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

export const isAndroid = () => /(android)/i.test(navigator.userAgent);

export const isChromebook = () => /(CrOS)/i.test(navigator.userAgent);

export const isChrome = () =>
  /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

export const isSafari = () =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const deviceCheck = () => {
  if (isAndroid()) {
    return "Android";
  } else if (isiOS()) {
    return "iOS";
  } else if (isChromebook()) {
    return "Chrome";
  }
  return "Desktop";
};

export const isInIframe = () => {
  // Don't let us be iframeable unless we are an embedded reader!
  try {
    if (window.top.location.href) {
      return false;
    } else {
      return true;
    }
  } catch (e) {
    return true;
  }
};

export const isIE11 = () =>
  window.navigator.userAgent.indexOf("Trident/7.0") > -1;
